import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar       from './components/Sidebar';
import Topbar        from './components/Topbar';
import Login         from './pages/Login';
import Dashboard     from './pages/Dashboard';
import Billing       from './pages/Billing';
import Orders        from './pages/Orders';
import Inventory     from './pages/Inventory';
import Recipes       from './pages/Recipes';
import Consumption   from './pages/Consumption';
import Loyalty       from './pages/Loyalty';
import Users         from './pages/Users';
import OnlineOrders  from './pages/OnlineOrders';
import Reports       from './pages/Reports';
import AdminPanel    from './pages/AdminPanel';

function ProtectedLayout() {
  const { user, can } = useAuth();
  if (!user) return <Navigate to="/login" />;
  const defaultPath = can('dashboard') ? '/dashboard' : can('billing') ? '/billing' : '/orders';
  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      <Sidebar />
      <div style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden' }}>
        <Topbar />
        <div style={{ flex:1, overflowY:'auto', padding:'18px 22px', background:'#f5f5f5' }}>
          <Routes>
            {can('dashboard')     && <Route path="/dashboard"     element={<Dashboard />} />}
            {can('billing')       && <Route path="/billing"       element={<Billing />} />}
            {can('orders')        && <Route path="/orders"        element={<Orders />} />}
            {can('inventory')     && <Route path="/inventory"     element={<Inventory />} />}
            {can('recipes')       && <Route path="/recipes"       element={<Recipes />} />}
            {can('consumption')   && <Route path="/consumption"   element={<Consumption />} />}
            {can('loyalty')       && <Route path="/loyalty"       element={<Loyalty />} />}
            {can('users')         && <Route path="/users"         element={<Users />} />}
            {can('online-orders') && <Route path="/online-orders" element={<OnlineOrders />} />}
            {can('reports')       && <Route path="/reports"       element={<Reports />} />}
            {can('admin-panel')   && <Route path="/admin"         element={<AdminPanel />} />}
            <Route path="*" element={<Navigate to={defaultPath} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*"    element={<ProtectedLayout />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}